import { TableContainer, TableHead, TableRow, TableBody, Pagination } from "@mui/material"
import { StyledTable, StyledTableCell, StyledTableRow } from "components/tables/StyledTable.tsx"
import { useCardHolderContext } from "layouts/card-holder/context/useCardHolderContext.ts"
import { CardHolderHeaderCell } from "layouts/card-holder/table/cardHolderHeaderCell.tsx"
import { getColumns, isRowHeader } from "layouts/card-holder/utils/const.ts"
import { DriverInfo, VehicleInfo } from "types/list-card-holder"

export const CardHolderTable = () => {
    const {
        currentRows,
        pageNumber,
        numberOfPages,
        handleChangePage,
        driverSelected,
        isVehicle,
        isRefetchingList,
    } = useCardHolderContext()

    const columns = getColumns(isVehicle)

    return (
        <>
            <TableContainer sx={{ borderRadius: "10px 10px 0 0" }}>
                <StyledTable aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <CardHolderHeaderCell
                                    key={String(column.key)}
                                    keyDriver={column.key as "name" | "description"}
                                    content={column.label}
                                    centered={column.centered}
                                    icon={column.icon}
                                    width={column.width}
                                />
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody
                        sx={{
                            "& td": {
                                opacity:
                                    driverSelected && !isRefetchingList
                                        ? 0.5
                                        : 1,
                            },
                        }}
                    >
                        {currentRows.map((row) => (
                            <StyledTableRow
                                key={row.id}
                                sx={{
                                    "& td": {
                                        opacity: !row.active ? 0.5 : 1,
                                    },
                                }}
                            >
                                {columns.map((column) => {
                                    const header = isRowHeader(String(column.key), isVehicle)
                                    return (
                                        <StyledTableCell
                                            key={`${row.id}-${String(column.key)}`}
                                            component={header ? "th" : "td"}
                                            scope={header ? "row" : undefined}
                                            align={column.centered ? "center" : "left"}
                                            sx={header ? { position: "relative" } : undefined}
                                        >

                                            {column.renderCell(row as VehicleInfo & DriverInfo)}
                                        </StyledTableCell>
                                    )
                                })}
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </TableContainer>

            <Pagination
                color="primary"
                count={numberOfPages}
                page={pageNumber}
                onChange={handleChangePage}
                sx={{
                    mx: "auto",
                }}
            />
        </>
    )
}
